<template>
  <div id="listWidget" class="mb-4">
    <div>
      <!-- 단계별 안내 -->
      <div class="instruction-card card-item mb-2">
        <div class="instruction-header">
          <i class="fa-solid fa-list-ol me-2 text-primary"></i>
          <span class="instruction-title">{{ props.title || '온도조절기 스캔' }}</span>
        </div>
        <div class="instruction-body">
          <div class="instruction-step">
            <div class="step-number">1</div>
            <div class="step-content">
              <span>제품 빨간색 LED가 빠르게 깜빡이는 상태를 확인해주세요.</span>
            </div>
          </div>
          <div class="instruction-step">
            <div class="step-number">2</div>
            <div class="step-content">
              <span>제품에 있는 QR 코드를 스캔해주세요.</span>
            </div>
          </div>
        </div>
      </div>
    
    <!-- QR 코드 촬영 버튼 -->
    <div class="action-button-container mb-3">
      <button
        type="button"
        class="btn btn-primary w-100"
        @click="onQRCodeRegistClick"
      >
        <i class="fa-solid fa-qrcode me-2"></i>
        QR 코드 촬영
      </button>
    </div>

    <!-- 시리얼 코드 입력 영역 -->
    <div class="input-card card-item mb-3">
      <div class="input-card-body">
        <input
          type="text"
          class="form-control form-control-lg fs-15px mb-3"
          placeholder="제품 시리얼 코드를 입력해주세요."
          v-model="serialCode"
        />
        <button
          type="button"
          class="btn btn-outline-primary w-100"
          @click="onRegistClick"
        >
          <i class="fa-solid fa-keyboard me-2"></i>
          제품 등록
        </button>
      </div>
    </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  getCurrentInstance,
  computed,
  onMounted,
  onBeforeUnmount,
  watch,
  reactive,
} from 'vue';
import QRCode from 'qrcode';
import Axios, { DeviceApi } from '@/api';
import { useStore } from 'vuex';
import { useRouter, onBeforeRouteLeave } from 'vue-router';
import useMobile from '@/common/hooks/useMobile';
import useMqttControl from '@/common/hooks/useMqttControl';
import { isAndroid, isIOS } from 'mobile-device-detect';
import { useMQTT } from 'mqtt-vue-hook';

const mqttControl = reactive(useMqttControl());
const { emitter, mobile, mqtt } = getCurrentInstance().appContext.config.globalProperties;
const props = defineProps(['handleNextStep', 'title', 'isUpdate']);
const store = useStore();
const router = useRouter();
const { 
  searchWifiList, 
  connectWifi,
  connectTempWifi, 
  connectTest, 
  readQRCode,
  showRegistView
} = useMobile();
const serialCode = ref('');
const mqttHook = mqttControl.getMqttHook()

let connectIntervalId = undefined;
let checkIntervalId = undefined;
let resIntervalId = undefined;
let sleepId = undefined;
let enableLeave = true;

onMounted(() => {
  // const canvas = document.getElementById('canvas');
  // QRCode.toCanvas(canvas, 'sertghbye345rytgw4e5tygw45erytgw43e5ytgw3e45tg3qw4tg3we4t5g', function (error) {
  //   if (error) {
  //     console.error(error);
  //     return;
  //   }

  //   canvas.style.width = "100%";
  //   canvas.style.height = "100%";
  //   canvas.style.padding = "2rem";
  //   canvas.style.paddingTop = "1rem";
  // });
});

onBeforeUnmount(() =>{
  mobile.disConnectWifi(JSON.stringify({
    ssid: serialCode.value,
    password: 'inshow75'
  }));  
})

onBeforeRouteLeave(async(to, from) => {
  if (store.getters["isLoading"] && enableLeave) {
    emitter.emit('showPopConfirm', {
      description: '세팅이 진행중입니다.\n절차를 중지하고 세팅모드를 종료하시겠습니까?',
      okCallback: () => {
        allStopProcess();
        return true;
      },
    });
    return false;
  }
  return true;
});

const allStopProcess = async () => {
  clearInterval(connectIntervalId);
  clearInterval(checkIntervalId);
  clearInterval(resIntervalId);
  clearTimeout(sleepId);
  emitter.off('onConnectResult');
  emitter.off('onSettingResult');
  emitter.emit('hideLoading', true);
  mobile.disConnectWifi(JSON.stringify({
    ssid: serialCode.value,
    password: 'inshow75'
  }));

  const serial = serialCode.value.slice(0, serialCode.value.indexOf("-"));
  const testTopic = `/inshow/${serial}/TEMPTARGETSET`;
  await mqttHook.unRegisterEvent("stat" + testTopic);
  await mqttHook.unSubscribe("stat" + testTopic, undefined);     
  router.go(-1);
};

const onQRCodeRegistClick = async () => {
  try {
    const result = await readQRCode();
    if (result?.length > 0) {
      serialCode.value = result;
    }
  } catch (e) {
    console.log(e);
    emitter.emit('showPopAlert', {
      description: "QR코드 인식에 실패했습니다.\n다시 시도해주세요."
    });
  }
}

const connectTempWifiSync = () => {
  enableLeave = false;
  return new Promise(async (resolve, reject) => {
    try {  
      emitter.emit('setLoadingText', '온도조절기에 연결하고 있습니다.');
      const result = await connectTempWifi({
        ssid: serialCode.value,
        password: 'inshow75'
      });
      if (result) {
        resolve(result);
        enableLeave = true;
        return;
      }
    } catch (e) {
      console.log(e);
    }

    let i = 1;
    connectIntervalId = setInterval(async () => {
      try {
        emitter.emit('setLoadingText', `온도조절기에 ${i + 1}번째 연결 시도하고 있습니다.`);
        const result = await connectTempWifi({
          ssid: serialCode.value,
          password: 'inshow75'
        });
        clearInterval(connectIntervalId);
        resolve(result);
        enableLeave = true;
      } catch (e) {
        console.log(e);
        if (i >= 4) {
          clearInterval(connectIntervalId);
          reject(e);
          enableLeave = true;
        }
      }
      i++; 
    }, 10500);
  });
}

const registTempWifi = async () => {
  try {
    const serial = serialCode.value.slice(0, serialCode.value.indexOf("-"));

    // if (isAndroid) {
    //   wifiItems.value = await searchWifiList();
    //   const foundItem = wifiItems.value.find(item => item.ssid == serialCode.value);
    //   if (!foundItem) {
    //     checkTempWifiConnected(serial, () => props.handleNextStep({
    //       serialCode: serialCode.value
    //     }), emitter.emit('showPopAlert', {
    //       description: "잘못된 제품 시리얼 코드 입니다.\n다시 확인해주세요."
    //     }));
    //     return;
    //   }
    // }

    let result = undefined;
    try {
      result = await connectTempWifiSync();
    } catch (e) {
      console.log(e);
      emitter.emit('showPopAlert', {
        description: e
      });
      return;
    }
    
    // const result = await connectTempWifi({
    //   ssid: 'inshowled',
    //   password: 'inshow22'
    // });
    

    console.log("result: ", result)
    if (result) {
      emitter.emit('setLoadingText', '와이파이 정보 등록 화면으로 이동하고 있습니다.');
      const isVisible = await showRegistView(true);

      console.log("isVisible: ", isVisible)
      if (isVisible) {
        console.log("sleep start");
        emitter.emit('showLoading');

        if (isIOS) {
          await mqtt.reconnect();
        }

        emitter.emit('setLoadingText', '온도조절기에 와이파이 정보를 설정하고 있습니다.\n약 10초간 대기합니다.');
        await sleep(10);

        emitter.emit('hideLoading');
        console.log("sleep end")

        let intervalCount = 0;
        emitter.emit('showLoading');
        resIntervalId = setInterval(async () => {
          try {

            console.log("intervalCount", intervalCount)
            if (intervalCount >= 10) {
              emitter.emit('showPopAlert', {
                description: '온도조절기로부터 응답을 받을 수 없습니다.'
              });
              clearInterval(resIntervalId);
              emitter.emit('hideLoading');
              return;
            }

            // const isAuthConnect = await mqttControl.connectAuth();
            // console.log("---------------------------------", isAuthConnect)
            // if (isAuthConnect) {
              emitter.emit('setLoadingText', intervalCount == 0 ? '온도조절기 응답을 기다리고 있습니다.' : `온도조절기 응답을 ${intervalCount + 1}번째 기다리고 있습니다.`);
              checkTempWifiConnected(serial, () => {
                clearInterval(resIntervalId);
                emitter.emit('hideLoading');
                props.handleNextStep({ serialCode: serialCode.value })
              }, () => {
                console.log("checkTempWifiConnected failed...", intervalCount)
              });
            // }

            // }), () => emitter.emit('showPopAlert', {
            //   description: '설정에 실패했습니다.'
            // }));

            console.log("intervalCount", intervalCount)
            intervalCount++;
          } catch(e) {
            console.log("connect auth mqtt: failed");
            intervalCount++;
          }
        }, 6000);
      } else {
        emitter.emit('showPopAlert', {
          description: 'wifi 등록을 취소하였습니다.'
        });
      }
    }
  } catch (e) {
    emitter.emit('showPopAlert', {
      description: e
    });
  }
}

const requestDeviceInfo = async (payload) => {
  try {
    emitter.emit('setLoadingText', '이미 등록된 온도조절기인지 확인하고 있습니다.');
    const result = await Axios.get(DeviceApi.DEVICE_INFO_BY_DATA, payload);
    if (result.resultCode === '0000' && result.resultData) {
      emitter.emit('showPopAlert', {
        description: "이미 등록된 장치입니다."
      });
      return;
    }    

    checkTempWifiConnected(payload.controllerId, () => props.handleNextStep({
      serialCode: serialCode.value
    }), registTempWifi);
  } catch (e) {
    console.log(e);
    // emitter.emit('showPopAlert', {
    //   description: 'WIFI 스캔 중 오류가 발생하였습니다.',
    // });
    checkTempWifiConnected(payload.controllerId, () => props.handleNextStep({
      serialCode: serialCode.value
    }), registTempWifi);
  }
}

const onRegistClick = async () => {
  if (serialCode.value.length === 0) {
    emitter.emit('showPopAlert', {
      description: "QR코드를 인식하거나\n수동으로 제품 시리얼 코드를 입력해주세요."
    });
    return;
  }

  const serial = serialCode.value.slice(0, serialCode.value.indexOf("-"));
  if (props.isUpdate) {
    checkTempWifiConnected(serial, () => props.handleNextStep({
      serialCode: serialCode.value
    }), registTempWifi);
    return;
  }

  requestDeviceInfo({
    controllerId: serial,
    name: serialCode.value
  });
}

const checkTempWifiConnected = async (serial, handleSuccess, handleFailure) => {
  emitter.emit('showLoading');

  const testTopic = `/inshow/${serial}/TEMPTARGETSET`;
  let intervalCount = 0;

  mqttHook.publish("cmnd" + testTopic, "18", 0);
  checkIntervalId = setInterval(async () => {
    if (intervalCount >= 4) {
      clearInterval(checkIntervalId);
      console.log("failed... : stat" + testTopic, intervalCount)

      await mqttHook.unRegisterEvent("stat" + testTopic);
      await mqttHook.unSubscribe("stat" + testTopic, undefined);      

      emitter.emit('hideLoading');

      if (handleFailure) {
        handleFailure();
      }
      return;
    }

    emitter.emit('setLoadingText', intervalCount == 0 ? '온도조절기 설정 여부를 확인하고 있습니다.' : `온도조절기 설정 여부 확인을 ${intervalCount + 1}번째 시도하고 있습니다.`);
    mqttHook.publish("cmnd" + testTopic, "18", 0);
    console.log("cmnd" + testTopic, "18")
    intervalCount++;
  }, 1000);

  mqttHook.subscribe(["stat" + testTopic], 0, undefined, async () => {
    await mqttHook.registerEvent("stat" + testTopic, async (topic,message) =>{
      console.log("success!!!!!!!!!!!", topic, message);
      
      if (topic.includes(testTopic)) {
        clearInterval(checkIntervalId);

        await mqttHook.unRegisterEvent(topic);
        await mqttHook.unSubscribe(topic, undefined);  

        emitter.emit('hideLoading');

        if (handleSuccess) {
          handleSuccess();
        }
      }
    });
  });
}

const test = () => {
  const serial = serialCode.value.slice(0, serialCode.value.indexOf("-"));
  const topic = `/inshow/${serial}/TEMPTARGETSET`;
  console.log("cmnd" + topic, "18")
  mqttHook.publish("cmnd" + topic, "18", 0);

  mqttHook.subscribe(["stat" + topic], 0, undefined, async () => {
    await mqttHook.registerEvent("stat" + topic, async (topic,message) =>{
      console.log(topic, message);
      await mqttHook.unRegisterEvent(topic);
      await mqttHook.unSubscribe(topic, undefined);  
    });
  });
}

const test2 = async () => {
  // const serial = serialCode.value.slice(0, serialCode.value.indexOf("-"));
  // const topic = `/inshow/${serial}/TEMPTARGETSET`;
  // console.log("cmnd" + topic, "18")
  // mqttHook.publish("cmnd" + topic, "18", 0);
  console.log("mqtt.isConnected()", mqtt.isConnected());
  await mqtt.reconnect();
  console.log("mqtt.isConnected()", mqtt.isConnected());
}

const sleep = (sec) => {
  return new Promise(resolve => {
    sleepId = setTimeout(resolve, sec * 1000);
  });
}
</script>

<style scoped>
.instruction-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.instruction-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.instruction-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #212529;
}

.instruction-body {
  padding: 0.75rem 1rem;
}

.instruction-step {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.instruction-step:last-child {
  margin-bottom: 0;
}

.step-number {
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0d6efd;
  color: white;
  border-radius: 50%;
  font-weight: 600;
  font-size: 0.75rem;
}

.step-content {
  flex: 1;
  padding-top: 0.1rem;
  font-size: 0.85rem;
  line-height: 1.5;
  color: #495057;
}

.step-content strong {
  color: #0d6efd;
  font-weight: 600;
}

.action-button-container {
  margin-top: 0;
}

.action-button-container .btn {
  padding: 0.625rem 1rem;
  font-size: 0.9rem;
  font-weight: 500;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.action-button-container .btn:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}

.input-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.input-card-body {
  padding: 1rem;
}
</style>